import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("nauta_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const capi = axios.create({ baseURL: BASE });
capi.interceptors.request.use((config) => {
  const t = localStorage.getItem("nauta_ctoken");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Error inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
